import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from "@angular/core";
import { LocalStorageService } from "src/app/services/shared/local-storage/local-storage.service";

@Component({
    selector: "app-historial-fuentes-panel",
    templateUrl: "./historial-fuentes-panel.component.html",
    styleUrls: ["./historial-fuentes-panel.component.scss"],
    standalone: false
})
export class HistorialFuentesPanelComponent implements OnChanges {
  @Input() dataHistorial: { id: string; "data.header"?:string;description: string, fechaFormat: string }[];
  @Input() dataHistorialModal: [];
  @Input() disabledHistorial: boolean = false;
  @Input() toggleValue: boolean = false;
  @Input() btnVisible:boolean = true;

  @Output() onSlideToggle: EventEmitter<boolean> = new EventEmitter<boolean>(false);
  @Output() onHistorySelected: EventEmitter<string> = new EventEmitter<string>(null);

  selectedBackUp: string = '';
  showModal: boolean = false;
  historySelect

  imgSelect = '<img src="assets/icons/efx-checkmark--green.png" />';



  ngOnChanges(changes: SimpleChanges): void {
    if (changes["dataHistorial"] && changes["dataHistorial"]["currentValue"])
      this.initList()
  }

  initList() {
    this.dataHistorial.forEach((data: { id: string; description: string }) => {
      if (data.description.includes("img")) data.description = this.selectedBackUp;
    });
  }

  toggleBasic(value: { checked: boolean }) {
    if (!value.checked) this.initList();

    this.onSlideToggle.emit(value.checked);
    this.toggleValue = value.checked;
  }

  historySelected(timeStamp: string) {
    this.dataHistorial.forEach((data: { id: string; description: string }) => {
      if (data.description.includes("img")) {
        data.description = data.description.split('/>')[1];
      }
      if (data.id === timeStamp && !data.description.includes("img")) {
        let desc = data.description;
        this.selectedBackUp = desc;
        const check = this.imgSelect.concat(desc);
        data.description = check;
      }
    });

    this.onHistorySelected.emit(timeStamp);
  }

  handleShowModal() {
    this.showModal = true;
    if (!this.showModal) this.initList();
    this.onSlideToggle.emit(this.showModal);
  }

  selectHistory(event) {
    const timeStamp = event

    const findSelectBackup = this.dataHistorial.find(history => String(history['data.header']) === String(timeStamp));

    this.selectedBackUp = findSelectBackup.fechaFormat;
    this.showModal = !this.showModal;
    this.onHistorySelected.emit(timeStamp);
  }

  closeModal(event) {
    this.showModal = event;
  }
}
